var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Información Adicional","storeName":"Additional_info","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"next-link":"/admin/verifications/edit/general","breadcrumbs":[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/additional_info'
      },
      {
        text: 'Información Adicional',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"description",fn:function({item}){return [_c('v-container',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"210px"},attrs:{"id":"scroll-target"}},[_c('v-row',{directives:[{name:"scroll",rawName:"v-scroll:#scroll-target",value:(_vm.onScroll),expression:"onScroll",arg:"#scroll-target"}]},[_c('p',[_vm._v(" "+_vm._s(item.description))])])],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }